import { setIn } from 'formik';
import moment from 'moment';
import React, { useEffect, useRef, useState } from 'react';
import Select from 'react-select'; // replace with actual import
import { IconArrowsExchange } from '@tabler/icons'; // replace with actual import

import { Tooltip } from '@mui/material';
import { FaSearch, FaTimesCircle, FaPlus, FaSave, FaTimes, FaMinus } from 'react-icons/fa';
import { FaCheck, FaPen } from 'react-icons/fa6';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import ReactSelect from 'react-select';
import ReactSelectCreatable from 'react-select/creatable';
import us from 'assets/images/dbDummy/us.png';
import eu from 'assets/images/dbDummy/eu.png';
import gbp from 'assets/images/dbDummy/ae.png';
import CreatableSelect from 'react-select/creatable';

import { getCurrencySymbol, numberFormatter } from 'utils/currency';
import CustomComboBox from 'ui-component/CustomComboBox';

const PurchaseOrderProductsModal = ({ onClose, onSubmit, currency = 'eur', preLoadedData, products, grades }) => {
    const compRef = useRef(null);
    // ## To close the popup ## //
    const handleClose = () => {
        onClose && onClose();
    };

    // ## To close the popup when clicked outside ## //
    const handleClickOutside = (event) => {
        if (compRef.current && !compRef.current.contains(event.target)) {
            // handleClose();
        }
    };

    useEffect(() => {
        document.addEventListener('click', handleClickOutside, true);
        return () => {
            document.removeEventListener('click', handleClickOutside, true);
        };
    }, []);

    // ## Dropdown Data ## //
    const [models, setModels] = useState([]);
    const [modelOptions, setModelOptions] = useState([]);
    
    const getSelectOptions = () => {
        setModels(products);


        const reactSelectOptions = products.map(item => ({
            value: item.id,
            label: item.product_name,
            htmlLabel: item.option_product_name,
            price: item.price,
            colors: item.colors,
            sku: item.sku,
            thumbnailUrl: item.thumbnail_url,
        }));
        setModelOptions(reactSelectOptions);

    };

    const [exchangeRate, setExchangeRate] = useState([]);
    const currencyOptions = [
        { value: 'USD', label: 'USD', image: us },
        { value: 'EUR', label: 'EUR', image: eu },
        { value: 'AED', label: 'AED', image: gbp }
    ];

    useEffect(() => {
        
        if (preLoadedData) {
            setModels(preLoadedData?.items);
            setDataItems(preLoadedData?.items || []);
        }
    }, []);

    useEffect(() => {
        getSelectOptions();
    }, []);

    // ## Invoice Data Handling ## //
    const [dataItems, setDataItems] = useState([
        {
            seqId: 1,
            quantity: 0,
            model: '',
            selectedColorId: '',
            selectedColorName: '',
            price: 0,
            commentToggle: false,
            colors: [],
            modelOptionsLoading: false,
            customValue: '',
            sku: '',
            thumbnailUrl: '',
        }
    ]);

    const [transitFee, setTransitFee] = useState(0);
    const [discount, setDiscount] = useState({
        discountType: 'percentage', // percentage, amount
        discountValue: 0
    });
    const shippingQty = 1;

    const newRowTemplate = {
        seqId: dataItems?.length + 1,
        quantity: 0,
        model: '',
        selectedColorId: '',
        selectedColorName: '',
        price: 0,
        commentToggle: false,
        colors: [],
        modelOptionsLoading: false,
        customValue: '',
        sku: '',
        thumbnailUrl: '',
    };


    useEffect(() => {
        if (dataItems.length > 0) {

            if ((dataItems.length > 0 && dataItems.every((it) => it.model || it.customValue))) {
                setDataItems((oldData) => [...oldData, newRowTemplate]);
            }
        } else {

            if ((dataItems?.every((it) => !!it.model)) || dataItems?.every((it) => !!it.customValue)) {
                setDataItems((oldData) => [...oldData, newRowTemplate]);
            }
        }
    }, [dataItems]);

    const [invalidData, setInvalidData] = useState(false);
    const [invalidDataMessage, setInvalidDataMessage] = useState('');
    useEffect(() => {
        let dataItemsCopy = dataItems.filter(item => item.model || item.customValue);
        
        if (dataItemsCopy?.length <= 0) {
            setInvalidData(true);
            setInvalidDataMessage('Please add at least one item');
        } else if (dataItemsCopy?.some((it) => !it.price)) {
            setInvalidData(true);
            setInvalidDataMessage('Please enter unit price for all items');
        } else {
            setInvalidData(false);
            setInvalidDataMessage('');
        }
    }, [dataItems]);

    // ## Handle Remove Inv Item ## //
    const handleRemoveInvItem = (index) => {
        setDataItems((oldData) => oldData.filter((item, i) => i != index));
    };

    // ## Handle Submit ## //
    const handleSubmit = () => {
        let dataItemsCopy = dataItems.filter(item => item.model || item.customValue);
        const preparedData = dataItemsCopy.map((item) => ({
            ...item,
            model: models?.find((m) => m.value == (item.model?.id || item.model)),
            customValue: item.customValue || '',
        }));
        
        onSubmit &&
            onSubmit({
                dataItems: preparedData,
                selections: {
                    models
                }
            });
    };

    const updateRow = (index, newData) => {
        setDataItems(items =>
            items.map((item, i) =>
                i === index ? { ...item, ...newData } : item
            )
        );
    };
    
    
    const comboBoxRefs = useRef([]);

    return (
        <div className="popup contact-popup product-popup d-none d-md-block" ref={compRef}>
            <div className="d-flex TableSerachBar align-items-center justify-content-between mb-2 ml-0 pl-0" style={{ paddingTop: '20px' }}>
                <h5 className="h5 mb-0  font-weight-bold flex-grow-1 pt-0" style={{ padding: '0 11px' }}>Products</h5>
                <button className="btn modal-close-icon" onClick={handleClose}>
                    <svg id="Component_127_1" height="16" width="16" data-name="Component 127 – 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 19.295 19.289">
                        <path id="Icon_ionic-ios-close" data-name="Icon ionic-ios-close" d="M23.219,20.933l6.891-6.891a1.615,1.615,0,0,0-2.284-2.284L20.935,18.65l-6.891-6.891a1.615,1.615,0,1,0-2.284,2.284l6.891,6.891L11.76,27.825a1.615,1.615,0,1,0,2.284,2.284l6.891-6.891,6.891,6.891a1.615,1.615,0,1,0,2.284-2.284Z" transform="translate(-11.285 -11.289)" />
                    </svg>
                </button>
            </div>
            <div style={{
                minHeight: '400px', 
                maxHeight: '500px', 
                overflowY: 'auto',
            }}>
                <div className="row m-0 p-0">
                    <table className="table inv-prods-add-table">
                        <thead>
                            <tr>
                                <th className="model-col">Model</th>
                                <th className="qty-col" style={{ width: '180px' }}>Color</th>
                                <th className="uprice-col" style={{ width: '115px' }}>Qty</th>
                                <th className="remove-col" style={{ width: '50px' }}></th>
                            </tr>
                        </thead>
                        <tbody>
                            {dataItems.map((item, index) => (
                                <>
                                    <tr key={item?.seqId}>
                                        <td className="model-col">

                                            <CustomComboBox
                                                ref={el => (comboBoxRefs.current[index] = el)}
                                                className="rs-container"
                                                classNamePrefix="rs"
                                                options={modelOptions}
                                                value={item.model
                                                        ? modelOptions?.find(v => v?.value == item?.model?.id)
                                                        : null
                                                    }
                                                inputValue={item.customValue || (
                                                    item.model
                                                        ? modelOptions?.find(v => v?.value == item.model)?.label
                                                        : ''
                                                )}
                                                onChange={(selected) => {
                                                    const colors = selected?.colors || [];
                                                    updateRow(index, {
                                                        model: selected?.__isNew__ ? '' : selected?.value || '',
                                                        customValue: selected?.__isNew__ ? selected?.value : '',
                                                        price: selected?.price || 0,
                                                        colors: colors,
                                                        selectedColorId: selected?.selectedColorId ?? '',
                                                        selectedColorName: selected?.selectedColorName ?? '',
                                                        sku: selected?.sku || '',
                                                        thumbnailUrl: selected?.thumbnailUrl || '',
                                                    });
                                                }}
                                                onInputChange={(input) => {
                                                    updateRow(index, {
                                                        customValue: input,
                                                        model: input ? '' : item.model,
                                                    });
                                                }}
                                                link={'products/create'}
                                                defaultMarginLeft={'0'}
                                            />
                                        </td>
                                        <td className="vat-col">
                                            {/* for colors selection */}
                                            {/* <ReactSelect
                                                className="rs-container"
                                                classNamePrefix="rs"
                                                options={
                                                    Array.isArray(item.colors)
                                                        ? item.colors.map(color => ({
                                                            label: color.label || color.name || color.value || color.id,
                                                            value: color.value ?? color.id ?? color.label ?? color.name
                                                        }))
                                                        : []
                                                }
                                                value={
                                                    Array.isArray(item.colors)
                                                        ? (() => {
                                                            const options = item.colors.map(color => ({
                                                                label: color.label || color.name || color.value || color.id,
                                                                value: color.value ?? color.id ?? color.label ?? color.name
                                                            }));
                                                            return options.find(opt => String(opt.value) === String(item.selectedColorId)) || null;
                                                        })()
                                                        : null
                                                }
                                                onChange={e => {
                                                    updateRow(index, {
                                                        selectedColorId: e?.value,
                                                        selectedColorName: e?.label
                                                    });
                                                }}
                                                placeholder="Select Color"
                                                menuPlacement="auto"
                                                menuPosition="fixed"
                                            /> */}
                                            <ReactSelect
                                                className="rs-container"
                                                classNamePrefix="rs"
                                                options={[
                                                    { label: 'No color', value: '' }, // Empty/default option
                                                    ...(Array.isArray(item.colors)
                                                        ? item.colors.map(color => ({
                                                            label: color.label || color.name || color.value || color.id,
                                                            value: color.value ?? color.id ?? color.label ?? color.name
                                                        }))
                                                        : [])
                                                ]}
                                                value={
                                                    (() => {
                                                        if (!item.selectedColorId) return null; // No default selected
                                                        const options = [
                                                            { label: 'No color', value: '' },
                                                            ...(Array.isArray(item.colors)
                                                                ? item.colors.map(color => ({
                                                                    label: color.label || color.name || color.value || color.id,
                                                                    value: color.value ?? color.id ?? color.label ?? color.name
                                                                }))
                                                                : [])
                                                        ];
                                                        return options.find(opt => String(opt.value) === String(item.selectedColorId)) || null;
                                                    })()
                                                }
                                                onChange={e => {
                                                    updateRow(index, {
                                                        selectedColorId: e?.value,
                                                        selectedColorName: e?.label
                                                    });
                                                }}
                                                placeholder="Select Color"
                                                menuPlacement="auto"
                                                menuPosition="fixed"
                                            />
                                        </td>
                                        <td className="qty-col">
                                           
                                            <div className='btn-group'>
                                                <button
                                                    className='btn btn-default btn-sm btn-left'
                                                    onClick={() => {
                                                        // decrease quantity
                                                        if ((item?.quantity) > 0) {
                                                            updateRow(index, {
                                                                quantity: Number(item?.quantity) - 1
                                                            });
                                                        }
                                                    }}
                                                >
                                                    <FaMinus />
                                                </button>
                                                <input
                                                    type='number'
                                                    value={item?.quantity ?? 0}
                                                    className='product-amount-field'
                                                    onChange={(e) => {
                                                        const cleanedValue = e.target.value.replace(/[^0-9]/g, '');
                                                        
                                                        updateRow(index, {
                                                            quantity: cleanedValue
                                                        }); 
                                                    }}
                                                    onFocus={(event) => {
                                                        if (event.target.value === '0') {
                                                            event.target.value = '';
                                                        }
                                                    }}
                                                    onBlur={(e) => {
                                                        if (e.target.value === '') {
                                                            updateRow(index, {
                                                                quantity: 0
                                                            });
                                                        }
                                                    }}
                                                />
                                                <button
                                                    className='btn btn-default btn-sm btn-right'
                                                    onClick={() => {
                                                        // increase quantity
                                                        updateRow(index, {
                                                            quantity: Number(item?.quantity) + 1,
                                                        });
                                                    }}
                                                >
                                                    <FaPlus />
                                                </button>

                                            </div>
                                        </td>
                                        <td className="remove-col">
                                            <div className="d-flex align-items-center" style={{ height: '32px' }}>
                                                <button
                                                    className="btn btn-remove"
                                                    disabled={index == dataItems?.length - 1}
                                                    onClick={() => {
                                                        handleRemoveInvItem(index);
                                                    }}
                                                >
                                                    <svg id="Component_127_1" height="12" width="12" data-name="Component 127 – 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 19.295 19.289">
                                                        <path id="Icon_ionic-ios-close" data-name="Icon ionic-ios-close" d="M23.219,20.933l6.891-6.891a1.615,1.615,0,0,0-2.284-2.284L20.935,18.65l-6.891-6.891a1.615,1.615,0,1,0-2.284,2.284l6.891,6.891L11.76,27.825a1.615,1.615,0,1,0,2.284,2.284l6.891-6.891,6.891,6.891a1.615,1.615,0,1,0,2.284-2.284Z" transform="translate(-11.285 -11.289)" />
                                                    </svg>
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                </>
                            ))}

                            <tr className="hr-row">
                                <td colSpan={7}>
                                    <hr style={{ marginBottom: '10px' }} />
                                </td>
                            </tr>

                            <tr>
                                <th className="text-right" colSpan={2}>
                                    Total Qty
                                </th>
                                <th className="text-left" style={{ verticalAlign: 'middle', fontWeight: 600 }}>
                                    {Number(
                                            dataItems
                                                .filter(item => item.model || item.customValue)
                                                .reduce((sum, item) => sum + Number(item?.quantity ?? 0), 0)
                                    ).toLocaleString()}
                                    { 
                                        dataItems
                                                .filter(item => item.model || item.customValue)
                                                .reduce((sum, item) => sum + Number((item?.quantity ?? 0), 0), 0) < 2 ? ' pc' : ' pcs'
                                    }
                                </th>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <div className="btnarea mb-3">
                <Tooltip title={invalidData ? invalidDataMessage : null} arrow placement="top">
                    <button className="btn btn-main" onClick={handleSubmit} disabled={invalidData}>
                        <FaSave /> Save 
                    </button>
                </Tooltip>
            </div>
        </div>
    );
};

export default PurchaseOrderProductsModal;
